import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Trip } from 'models';
import { TripService } from 'services';

@Injectable({
    providedIn: 'root'
})
export class TripsResolver implements Resolve<Trip[]> {
    constructor(private tripService: TripService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Trip[]> {
        return this.tripService.get();
    }
}
